import { useLocation } from "react-router-dom";
import { cn } from "@fmc-digital/ui";
import { RegistrationFeedbackSurveyBanner } from "@/components/molecules/RegistrationFeedbackSurveyBanner/RegistrationFeedbackSurveyBanner";
import { RegistrationFeedbackNps } from "@/components/organisms/RegistrationFeedbackNps/RegistrationFeedbackNps";
import type { RegisterFeedbackLocationState } from "@/pages/register/feedback/register-feedback.navigation";
import {
  registerFeedbackContentStyles,
  registerFeedbackPageStyles,
} from "./register-feedback.styles";

export function RegisterFeedbackPage() {
  const location = useLocation();
  const registeredEmail = (location.state as RegisterFeedbackLocationState | null)?.username;

  return (
    <div className={cn(registerFeedbackPageStyles())}>
      <div className="relative left-1/2 w-screen max-w-none -translate-x-1/2">
        <RegistrationFeedbackSurveyBanner />
      </div>
      <div className={cn(registerFeedbackContentStyles())}>
        <RegistrationFeedbackNps username={registeredEmail} />
      </div>
    </div>
  );
}
